<!--
 * @Author: your name
 * @Date: 2021-07-08 15:07:37
 * @LastEditTime: 2021-08-26 20:10:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\advertisementUnit.vue
-->
 
<template>
<div class="advertisement-wrapper">
    <div class="advertisement-hidden" v-if="advertisementData.isHidden">
        <el-divider>广告区</el-divider>
        <div class="open-btn" >
            <eui-btn width="80" type="primary" @click.native.prevent="hiddenFloor"
          >显示</eui-btn
        >
        </div>
    </div>
    <div  class="advertisement-content" :class="{'content-border':showBorder}" v-else>
        <div v-if="advertisementData.advertisementList.length>0">
            <div class="advertisement-list"   v-for="(item,index) in advertisementData.advertisementList" :key="index">
                <p @click="showDialog(item)"  >
                    <el-image 
                        style="width: 1200px; height: 140px"
                        :src="item.imgUrl" fit="fit">
                    </el-image>
                </p>
                <!-- <div class="hidden-btn" >
                    <el-button @click.native.prevent="hiddenFloor" type="danger" icon="el-icon-arrow-down">隐藏</el-button>
                </div> -->
            </div>
        </div>
        <div v-else class="advertisement-list" >
                <p @click="showDialog('')"><img src="./img/advertisement.png" alt="" width="1200px" height="140px"></p>
                <!-- <div class="hidden-btn" >
                    <el-button @click.native.prevent="hiddenFloor" type="danger" icon="el-icon-arrow-down">隐藏</el-button>
                </div> -->
           
        </div>
    </div>
</div>
</template>

<script>
export default {    
    props:{
        activeName: {
            type: String,
            default: ''
        },
        advertisementData: {
          type: Object,
          default: function () {
            return {
                isHidden:false,
                advertisementList:[]
            }
          }
        },
    },
    computed: {
        showBorder(){
            return  this.activeName=='advertisement'?true:false
        }
    },
   
    data(){
        return {
            isHidden:false,
        }
    },
    methods:{
        showDialog(data){
            this.$parent.choosenComments('advertisement');
                let arr=[]
                if(data){
                    arr.push(data)
                }
                this.advertisementData.advertisementList=arr;
           
        },
        hiddenFloor(){
            this.advertisementData.isHidden=!this.advertisementData.isHidden;
            this.$parent.choosenComments('');
        }
    }

}
</script>

<style lang="scss" scoped>
.advertisement-content{
    width: 1200px;
    height: 140px;
    background: #999;
    position: relative;
    
    // .hidden-btn{
    //     display: none;
    //     position: absolute;

    //     z-index: 100;
    //     top:0;
    //     right:0;
    // }
    .advertisement-list{
        width: 100%;
        height: 100%;
    }
}
// .advertisement-content:hover{
//     box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
//     .hidden-btn{
//         display: block;
//     }
// }
.advertisement-hidden{
  width: 1200px;
 
  background: #F8F8F9;
  position: relative;
  .open-btn{
       position: absolute;
        top:-16px;
        right:0;
  }
  p{width: 100%;
    height: 0;
    border-top: 1px solid #eee;
  }
}
.content-border:after{
    content: "";
    position: absolute;
    left: 0px;
    bottom:0;
    top:0;
    right:0;
    border:2px dashed red;  
}
</style>
